export const propertiesSeparator = '|';
export const productVariantsSeparator = ';';
